import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

export interface UpdateCustomer {
  clienteId?: number;
  diasAdicionaisParaPostagem?: number;
  imporCorreios?: boolean;
  tipoVeiculoColeta?: string;
  notificaDestinatario?: boolean;
  categoriaClienteId?: number;
  optanteSimplesNacional?: boolean;
  bloquearAutomaticamente?: boolean;
  possuiIsencaoFaturamentoMinimo?: boolean;
  horariosInicioExpediente?: { [key: number]: string; };
  horariosEncerramentoExpediente?: { [key: number]: string; };
  inicioExpedientePausa?: string;
  fimExpedientePausa?: string;
  dataHoraAtualizacaoCobranca?: string;
  tempoParada?: number;
  coletaEscalonadaSegunda?: boolean;
  horaLimiteColetaSegunda?: string;
  coletaEscalonadaTerca?: boolean;
  horaLimiteColetaTerca?: string;
  coletaEscalonadaQuarta?: boolean;
  horaLimiteColetaQuarta?: string;
  coletaEscalonadaQuinta?: boolean;
  horaLimiteColetaQuinta?: string;
  coletaEscalonadaSexta?: boolean;
  horaLimiteColetaSexta?: string;
  formaColeta: string;
  coletaAtiva: Boolean;
}

export interface CustomerData {
  id: number;
  nome: string;
  email: string;
  telefone: Phone;
  cpf: string;
  cnpj: string;
  razaoSocial: string;
  inscricaoEstadual: string;
  gastoMensalComFrete: string;
  pj: boolean;
  plano: string;
  horaLimiteMesmoDiaPostagem: string;
  horaLimiteColeta: string;
  idMixpanel: string;
  enderecos: Address[];
  planoContrato: ContractPlan;
  contaLegado: boolean;
  aceiteTermoContrato: boolean;
  aceitaDevolucao: boolean;
  modoDemonstracao: boolean;
  categoriaCliente: Category;
  situacaoCadastral: string;
  horaLimiteColetaSegunda: string;
  horaLimiteColetaTerca: string;
  horaLimiteColetaQuarta: string;
  horaLimiteColetaQuinta: string;
  horaLimiteColetaSexta: string;
  aceiteAtualizacaoTermoContrato: boolean;
}

export interface Address {
  id: number;
  nome: string;
  logradouro: string;
  bairro: string;
  cep: string;
  cidade: string;
  numero: string;
  complemento: string;
  uf: string;
  ativo: boolean;
  remetente: string;
  etiqueta: Address;
  latitude: number;
  longitude: number;
  coletaHabilitada: boolean;
  logisticaReversaHabilitada: boolean;
  enderecoDeDevolucao: boolean;
  areaDedicadaColeta: string;
}

export interface Phone {
  id: number;
  numero: string;
  ddd: number;
}

export interface Category {
  id: number;
  nome: string;
  idDepartamentoZendesk: number;
  reguaCobranca: BillingNotification;
}

export interface ContractPlan {
  codigo: string;
  recorrencia: number;
  padrao: boolean;
  tipo: string;
  faturamentoMinimo: number;
  formaPagamento: string;
  servicoEmpacotamento: boolean;
  possuiGerenteConta: boolean;
  tipoColeta: string;
  tipoAtendimento: string;
  tipoIntegracoes: string;
  vencimento1aQuinzena: number;
  vencimento2aQuinzena: number;
  freedom: boolean;
  soft: boolean;
  flex: boolean;
}

export interface BillingNotification {
  id: number;
  nome: string;
  diasPagamentoNaoIdentificado: number;
  diasAvisoBloqueio: number;
  diasBloqueio: number;
}

export interface Prefixes {
  prefixos: string[];
}

@Injectable()
export class CustomerService {

  private URL: string = environment.angularJSconstants.URLAPICLIENTE;

  constructor(private http: HttpClient) {}

  getPrefixes(id: number): Observable<Prefixes> {
    return this.http.get<Prefixes>(`${this.URL}/clientes/${id}/prefixos`);
  }

  updateCustomer(id: number, data: UpdateCustomer): Observable<void> {
    return this.http.patch<void>(`${this.URL}/clientes/${id}`, data);
  }

  getData(): Observable<CustomerData> {
    return this.http.get<CustomerData>(`${this.URL}/me`);
  }

  updateData(data): Observable<void> {
    return this.http.put<void>(`${this.URL}/me`, data);
  }

  updateAcceptReturn(id: number, acceptReturn: boolean): Observable<void> {
    return this.http.put<void>(`${this.URL}/cliente/${id}/accept-return`, { acceptReturn });
  }

  notifyNewCollectionData(id: number) {
    return this.http.post<void>(`${this.URL}/coletas/${id}/notificar-cadastro`, {});
  }
}
